<template>
  <nav class="footer-menu">
    <div v-for="(group, idx) in footerMenusGroups" :key="idx">
      <FooterMenuGroup :menu="group" />
    </div>
  </nav>
</template>

<script setup lang="ts">
  import { FooterMenuGroup } from '~/components/layouts/footer/index'
  import { footerMenusGroups } from '~/shared/const/menu'
</script>

<style scoped lang="scss">
  .footer-menu {
    @extend %flex-inline;

    gap: 120px;

    @include vp-1439 {
      gap: 10%;
      margin-top: 32px;
      justify-content: flex-start;
    }

    @include vp-767 {
      margin-top: 24px;
      flex-direction: column;
      gap: 0;
    }
  }
</style>
